import React from 'react'
import { CountdownBadge } from '@mobi/component-library/Feedback/CountdownBadge'
import { StatusBadge } from '@mobi/component-library/Feedback/StatusBadge'
import { dayjs } from '@mobi/utils/date'
import {
  getLegStatus,
  getStatusText,
} from '@core/Areas/Account/Pages/Activity/Components/Ticket/helpers'
import { TicketDisplayContext } from '@core/Areas/Account/Pages/Activity/context'
import type { BetStatus, Ticket } from '@core/Areas/Account/Pages/Activity/types'

export const CountdownStatus: React.FC<{ multiLeg: Ticket['legs'][0] }> = ({ multiLeg }) => {
  const ticketContext = React.useContext(TicketDisplayContext)
  const isShareContext = ticketContext.type === 'share'
  const isShareInFeed = isShareContext && ticketContext.data.display === 'bet-loop'

  const legStatus = getLegStatus(multiLeg.result)

  if (legStatus === 'Pending') {
    const countdownDate = multiLeg.advertisedStartTime
    if (!countdownDate) return null

    if (isShareContext && !isShareInFeed) {
      return (
        <StatusBadge color='gray' badgeSize='S'>
          {dayjs(countdownDate).format('D MMM | H:mm')}
        </StatusBadge>
      )
    }
    return <CountdownBadge badgeSize='S' advertisedStartTime={new Date(countdownDate)} />
  }

  const betLegStatus = getBetLegStatus(legStatus)
  return betLegStatus ? (
    <StatusBadge badgeSize='S' color={legStatus === 'Won' ? 'success' : 'neutral'}>
      {betLegStatus}
    </StatusBadge>
  ) : null
}

// =============
// Local Helpers
// =============

function getBetLegStatus(legStatus: BetStatus): string | null {
  if (legStatus === 'Lost' || legStatus === 'Won') {
    return null
  }

  return getStatusText(legStatus)
}
